<template>
  <base-layout redirectTo="home">
    <contact-content isFromContact />
  </base-layout>
</template>

<script>
export default {
  components: {
    BaseLayout: () => import('@/components/layout/BaseLayout.vue'),
    ContactContent: () => import('@/modules/units/views/components/ContactContent.vue')
  }
}
</script>
